import { SitePage } from "./pages/SitePage";

// Single-page studio site. Booking is by phone or email and the contact form
// uses EmailJS, so there is no admin surface and no router.
export default function App() {
  return <SitePage />;
}
